import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { formatCurrency, formatDate, monthLabel } from "@/lib/format";

export function exportTransactionsCSV(transactions, currency = "MXN") {
  const headers = ["Fecha", "Tipo", "Categoría", "Monto", "Nota"];
  const rows = transactions.map((t) => [
    t.date,
    t.type === "income" ? "Ingreso" : "Gasto",
    t.category,
    t.amount.toFixed(2),
    (t.note || "").replace(/"/g, '""'),
  ]);
  const csv = [headers, ...rows]
    .map((r) => r.map((v) => `"${v}"`).join(","))
    .join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `transacciones_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function exportTransactionsPDF(transactions, summary, month, year, currency = "MXN") {
  const doc = new jsPDF();
  // Header
  doc.setFontSize(20);
  doc.setTextColor("#2C352D");
  doc.text("Reporte de Finanzas", 14, 18);

  doc.setFontSize(11);
  doc.setTextColor("#5C625B");
  doc.text(`Periodo: ${monthLabel(month, year)}`, 14, 26);

  // Summary
  doc.setFontSize(11);
  doc.setTextColor("#2C352D");
  if (summary) {
    doc.text(`Ingresos: ${formatCurrency(summary.total_income, currency)}`, 14, 38);
    doc.text(`Gastos: ${formatCurrency(summary.total_expense, currency)}`, 14, 44);
    doc.setFont(undefined, "bold");
    doc.text(`Saldo: ${formatCurrency(summary.balance, currency)}`, 14, 50);
    doc.setFont(undefined, "normal");
  }

  // Table
  autoTable(doc, {
    startY: 58,
    head: [["Fecha", "Tipo", "Categoría", "Monto", "Nota"]],
    body: transactions.map((t) => [
      formatDate(t.date),
      t.type === "income" ? "Ingreso" : "Gasto",
      t.category,
      formatCurrency(t.amount, currency),
      t.note || "",
    ]),
    styles: { fontSize: 9, cellPadding: 3 },
    headStyles: { fillColor: [96, 125, 99], textColor: 255 },
    alternateRowStyles: { fillColor: [249, 248, 246] },
  });

  doc.save(`reporte_finanzas_${year}-${String(month).padStart(2, "0")}.pdf`);
}
